<template>
  <div class="row">
    <div class="col-md-12">
      <div class="settings">
        <b-card no-body>
          <b-tabs v-model="tabIndex" medium card>
            <b-tab title="User Role Settings" class="color-333333">
              <UserRoleSettings v-if="tabIndex === 0" />
            </b-tab>

            <b-tab title="Locked Logins" class="color-333333">
              <LockedLogins v-if="tabIndex === 1" />
            </b-tab>

            <b-tab title="Login Records" class="color-333333">
              <LoginRecords v-if="tabIndex === 2" />
            </b-tab>

            <b-tab title="Security" class="color-333333">
              <SecurityInfo v-if="tabIndex === 3" />
            </b-tab>

            <b-tab title="Pricelist" class="color-333333">
              <PriceList v-if="tabIndex === 4" />
            </b-tab>

            <b-tab title="Buy Group Dates" class="color-333333">
              <BuyGroupDates v-if="tabIndex === 5" />
            </b-tab>

            <b-tab title="Free Shipping" class="color-333333">
              <FreeShippingSettings v-if="tabIndex === 6" />
            </b-tab>

            <b-tab title="Order Minimum Qty Settings" class="color-333333">
                <OrderMinimumQtySettings v-if="tabIndex === 7" />
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, watch } from 'vue';
import { useStore } from "vuex";
import { useRoute } from 'vue-router';

import UserRoleSettings from "./UserRoleSettings.vue";
import LockedLogins from './LockedLogins.vue';
import LoginRecords from './LoginRecords.vue';
import SecurityInfo from './SecurityInfo.vue';
import PriceList from './PriceList.vue';
import BuyGroupDates from '../buy-group-dates/BuyGroupDates.vue';
import FreeShippingSettings from '../FreeShippingSettings.vue';
import OrderMinimumQtySettings from './OrderMinimumQtySettings.vue';

export default {
  components: {
    UserRoleSettings,
    LockedLogins,
    LoginRecords,
    SecurityInfo,
    PriceList,
    BuyGroupDates,
    FreeShippingSettings,
    OrderMinimumQtySettings
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const tabMapping = {
      'roles': 0,
      'locked': 1,
      'records': 2,
      'security': 3,
      'pricelist': 4,
      'buygroup': 5,
      'freeshipping': 6,
      'minquantity': 7,
    };

    return {
      user: computed(() => store.state.user),
      route,
      tabMapping
    };
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  mounted() {
    const tabParam = new URLSearchParams(window.location.search).get('tab');
    if (tabParam && this.tabMapping[tabParam] !== undefined) {
      this.tabIndex = this.tabMapping[tabParam];
    }
  },
  methods: {
    updateTabQuery() {
      const tabNames = Object.keys(this.tabMapping);
      const tabName = tabNames[this.tabIndex];
      if (tabName) {
        const url = new URL(window.location);
        url.searchParams.set('tab', tabName);
        window.history.pushState({}, '', url);
      }
    }
  },
  watch: {
    tabIndex(newIndex) {
      this.updateTabQuery();
    },
    '$route.query.tab'(newTab) {
      if (newTab && this.tabMapping[newTab] !== undefined) {
        this.tabIndex = this.tabMapping[newTab];
      }
    }
  }
}
</script>
